import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isNil, isEmpty } from 'lodash';
import locale from 'antd/lib/date-picker/locale/el_GR';
import {
  Select,
  DatePicker,
  Row,
  Col,
  Table,
  Divider,
  Space,
  Tooltip,
  Spin,
  AutoComplete,
  Input,
  Modal,
} from 'antd';
import { ReactComponent as SearchIcon } from '../../../assets/icons/search_icon.gov.svg';
import { ReactComponent as ArrowIcon } from '../../../assets/icons/dropdown-arrow.svg';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/calendar.gov.svg';
import {
  clearSayt,
  fetchVoucherStatuses,
  fetchVoucherStatusesVoucherViewer,
  fetchProcInstancesSupplierPaginated,
  fetchProcInstancesVoucherAuditorPaginated,
  fetchProcInstancesDetailedPaginated,
  fetchProcInstancesVoucherViewerPaginated,
  getAllTaskNames,
  fetchVoucherByNuber,
  fetchVoucherVoucherAuditorWithParams,
  cancelProcessInstanceExtended,
  cancelAcceptedProcessInstance,
  unassignProcessInstanceExtended,
  setVoucherErrorDescription,
  releaseApplication,
  setReleaseApplicationErrorDescription,
  fetchVoucherByNuberVoucherViewer,
} from 'store/appTrack/actions';
import { ReactComponent as ActionsIcon } from '../../../assets/icons/more_dots.svg';
import { ReactComponent as FilterIcon } from '../../../assets/icons/filter_lines.svg';
import { ReactComponent as FilterIconBold } from '../../../assets/icons/filter_lines_bold.svg';
import Popover from '@mui/material/Popover';
import ActionList from './components/ActionList';
import TableCell from './components/TableCell';
import moment from 'moment';
import { StatusTag, Button } from 'components';
import { checkFieldVoucher } from './components/utilis';
import {
  isSupplier,
  isBeneficiary,
  isVoucherAuditor,
  isAuditor,
  isObjectionCommittee,
  isVoucherViewer,
} from 'utils';
import { getLocalString, localNames } from 'utils/localisation.service';
import { useNavigate } from 'react-router-dom';
import NoResults from './components/NoResults';
import { getSystemLocales, clearForm } from 'store/forms/actions';
import { setActiveFormId } from 'store/activeForm/actions';
import { checkUser, getUser, getTaxisData } from 'store/user/actions';
import { ReactComponent as CancelWarningIcon } from '../../../assets/icons/cancel_warning_icon.svg';
import { getFullDateTimeWithSeconds, getFullDateTime } from 'utils/helpers';
import { kadArray } from 'utils/kadArray';
import { handleCheckUniqueness } from 'utils';
import { checkUniqueness, updateFormField } from 'store/forms/actions';
import InfoMessage from '../../../components/infoMessage';

const AppTrackPage1 = ({ disabled }) => {
  const viewMode = false;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedProcId, setSelectedProcId] = useState();
  const [selectedVoucher, setSelectedVoucher] = useState('');
  const [selectedSupplierVat, setSelectedSupplierVat] = useState('');
  const [isFiltersVisible, setFiltersVisible] = useState(false);
  const [filterImg, setFilterImg] = useState(<FilterIcon />);
  const user = useSelector(state => state.user);
  const userStatus = useSelector(state => state.user.status);
  const [saytOptions, setSaytOptions] = useState([]);
  //const saytOptions = useSelector(state => state.appTrack.sayt);
  const [detailedPayload, setDetailedPayload] = useState({ parameterList: [] });
  const privileges = useSelector(state => state.user.privileges);
  const groups = useSelector(state => state.user.groups);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(Boolean(anchorEl));
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const resultsBeneficiary = useSelector(state => state.appTrack.variables);
  const resultsSupplier = useSelector(
    state => state.appTrack.supplier.variables
  );
  const resultsVoucherAuditor = useSelector(
    state => state.appTrack.voucherAuditor.variables
  );
  const resultSizeSupplier = useSelector(
    state => state.appTrack.supplier.resultSize
  );
  const resultSizeVoucherAuditor = useSelector(
    state => state.appTrack.voucherAuditor.resultSize
  );
  const results =
    isSupplier(groups) || isVoucherViewer(groups)
      ? resultsSupplier
      : isVoucherAuditor(groups)
        ? resultsVoucherAuditor
        : resultsBeneficiary;
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const locales = useSelector(state => state.forms?.localeStrings);
  const loadingPage = useSelector(state => state.appTrack.loadingApptrack);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSizeFlag, setPageSizeFlag] = useState(5);
  const resultSize = useSelector(state => state.appTrack.resultSize);
  const taskNames = useSelector(state => state.appTrack.taskNames);
  const voucherStatuses = useSelector(state => state.appTrack.voucherStatuses);
  const sayt = useSelector(state => state.appTrack.sayt);
  const [cancelModal, setCancelModal] = useState(false);
  const [cancelModalEquipment, setCancelModalEquipment] = useState(false);
  const [cancelModalService, setCancelModalService] = useState(false);
  const [cancelModalAccepted, setCancelModalAccepted] = useState(false);
  const [cancelModalServiceAccepted, setCancelModalServiceAccepted] = useState(false);
  const [unassignModalService, setUnassignModalService] = useState(false);
  const [releaseEquipmentModal, setReleaseEquipmentModal] = useState(false);
  const [releaseServiceModal, setReleaseServiceModal] = useState(false);
  const checkUniquenessCreate = useSelector(
    state => state.forms.checkUniquenessCreate
  );
  const iniFlag = useSelector(state => state.user.taxis_data.iniFlag);
  const [voucherEquipmentNumber, setVoucherEquipmentNumber] = useState('');
  const [voucherServiceNumber, setVoucherServiceNumber] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);
  const loadingLocales = useSelector(state => state.forms.loadingLocales);
  const loadingTaxis = useSelector(state => state.user.loading);
  const voucherErrorMessage = useSelector(
    state => state.appTrack?.voucherErrorMessage
  );
  const releaseApplicationError = useSelector(
    state => state.appTrack?.releaseApplicationError
  );
  const [voucherError, setVoucherError] = useState(false);
  const [releaseApplicationErrorModal, setReleaseApplicationErrorModal] =
    useState(false);
  const [afmField, setAfmField] = useState(null);
  const [afmError, setAfmError] = useState(false);

  const [applicationNumber, setApplicationNumber] = useState(null);
  const [applicationNumberError, setApplicationNumberError] = useState(false);

  const [voucherNumber, setVoucherNumber] = useState(null);
  const [voucherNumberError, setVoucherNumberError] = useState(false);
  useEffect(() => {
    const storedLanguage = localStorage.getItem('appLanguage');
    dispatch(getSystemLocales(storedLanguage));
    dispatch(checkUser(navigate));
    dispatch(getUser());
    dispatch(getTaxisData());
    dispatch(clearForm());
    // dispatch(fetchProcInstancesDetailedPaginated(detailedPayload,currentPage, pageSizeFlag));
    dispatch(getAllTaskNames());
  }, [dispatch, navigate]);

  useEffect(() => {
    if (user?.taxis_data?.afm) {
      handleCheckUniqueness({
        user,
        apptrack: true,
        dispatch,
        checkUniqueness,
      }).then(res => {
        // const reasons = {
        //   case: 'checkUniqueness',
        //   acceptable: true,//res.acceptable,
        // };
        dispatch(
          updateFormField({
            group: 'checkUniquenessCreate',
            key: 'canCreate',
            value: res.acceptable,
          })
        );
      });
    }
  }, [user?.taxis_data?.afm]);

  useEffect(() => {
    if (!isEmpty(voucherErrorMessage)) {
      setVoucherError(true);
    } else {
      setVoucherError(false);
    }
  }, [voucherErrorMessage]);

  useEffect(() => {
    if (!isEmpty(releaseApplicationError)) {
      setReleaseApplicationErrorModal(true);
    } else {
      setReleaseApplicationErrorModal(false);
    }
  }, [releaseApplicationError]);

  const handleAfmChange = e => {
    const value = e.target.value;
    setAfmField(value === '' ? null : value);
    setAfmError(value.length !== 9 && value.length > 0);
  };

  const handleΑpplicationNumberChange = e => {
    const value = e.target.value;
    setApplicationNumber(value === '' ? null : value);
    setApplicationNumberError(value.length !== 6 && value.length > 0);
  };

  const handleVoucherChange = e => {
    const value = e.target.value;
    setVoucherNumber(value === '' ? null : value);
    setVoucherNumberError(value.length !== 9 && value.length > 0);
  };

  const dateFormat = 'DD/MM/YYYY';
  const marks = {
    0: '0 €',
    2000: '2.000 €',
  };
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSizeFlag(pageSize);
    dispatch(
      fetchProcInstancesDetailedPaginated(detailedPayload, page, pageSize)
    ); //empty param list
  };

  //SUPPLIER
  const handlePageChangeVoucher = (page, pageSize) => {
    setCurrentPage(page);
    setPageSizeFlag(pageSize);
    dispatch(
      fetchProcInstancesSupplierPaginated(detailedPayload, page, pageSize)
    ); //empty param list
  };
  //Voucher VIEWER
  const handlePageChangeVoucherViewer = (page, pageSize) => {
    setCurrentPage(page);
    setPageSizeFlag(pageSize);

    dispatch(
      fetchProcInstancesVoucherViewerPaginated(
        detailedPayload,
        page,
        pageSize,
        afmField || null,
        voucherNumber || null
      )
    );
  };

  useEffect(() => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    if (isSupplier(groups)) {
      if (
        !isNil(afmField) &&
        afmField?.length === 0 &&
        !isNil(voucherNumber) &&
        voucherNumber?.length === 0
      ) {
        detailedPayloadTmp.parameterList = [];
        dispatch(
          fetchProcInstancesSupplierPaginated(
            detailedPayloadTmp,
            1,
            pageSizeFlag
          )
        );
      }
    } else if (isVoucherAuditor(groups)) {
      if (isNil(afmField) && isNil(voucherNumber) && isNil(applicationNumber)) {
        detailedPayloadTmp.parameterList = [];
        dispatch(
          fetchProcInstancesVoucherAuditorPaginated(
            detailedPayloadTmp,
            1,
            pageSizeFlag
          )
        );
      } else if (isVoucherViewer(groups)) {
        if (
          !isNil(afmField) &&
          afmField?.length === 0 &&
          !isNil(voucherNumber) &&
          voucherNumber?.length === 0
        ) {
          detailedPayloadTmp.parameterList = [];
          detailedPayloadTmp.vatId = afmField || null;
          detailedPayloadTmp.voucherNumber = voucherNumber || null;

          dispatch(
            fetchProcInstancesVoucherViewerPaginated(
              detailedPayloadTmp,
              1,
              pageSizeFlag
            )
          );
        }
      }
    }
  }, [afmField, voucherNumber, applicationNumber]);

  // useEffect(() => {
  //   const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

  //   if (isVoucherViewer(groups)) {
  //     if (
  //       !isNil(afmField) && afmField?.length === 0 &&
  //       !isNil(voucherNumber) && voucherNumber?.length === 0
  //     ) {
  //       detailedPayloadTmp.parameterList = [];
  //       detailedPayloadTmp.vatId = afmField || null;
  //       detailedPayloadTmp.voucherNumber = voucherNumber || null;

  //       dispatch(fetchProcInstancesVoucherViewerPaginated(detailedPayloadTmp, 1, pageSizeFlag));
  //     }
  //   }
  // }, [afmField, voucherNumber, applicationNumber]);

  //VOUCHER AUDITOR
  const handlePageChangeVoucherAuditor = (page, pageSize) => {
    setCurrentPage(page);
    setPageSizeFlag(pageSize);
    dispatch(
      fetchProcInstancesVoucherAuditorPaginated(detailedPayload, page, pageSize)
    ); //empty param list
  };

  const renderTitle = title => <span>{title}</span>;

  const renderItem = title => ({
    value: title,
    label: (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {title}
      </div>
    ),
  });

  const toggleFilters = () => {
    setFiltersVisible(!isFiltersVisible);
    if (isFiltersVisible) {
      setFilterImg(<FilterIconBold />);
    } else {
      setFilterImg(<FilterIcon />);
    }
  };

  const overFilter = () => {
    setFilterImg(<FilterIconBold />);
  };

  const outFilter = () => {
    if (isFiltersVisible) {
      setFilterImg(<FilterIconBold />);
    } else {
      setFilterImg(<FilterIcon />);
    }
  };

  const cancelProcess = selectedProcId => {
    dispatch(cancelProcessInstanceExtended(selectedProcId, true)); // isEquipment = true
    setCancelModal(false);
  };

  const cancelProcessEquipment = selectedProcId => {
    dispatch(cancelProcessInstanceExtended(selectedProcId, true)); // isEquipment = true
    setCancelModalEquipment(false);
  };

  const cancelProcessService = selectedProcId => {
    dispatch(cancelProcessInstanceExtended(selectedProcId, false)); // isEquipment = false -> Cancel only Voucher Service
    setCancelModalService(false);
  };


  const cancelProcessAccepted = selectedProcId => {
    dispatch(cancelAcceptedProcessInstance(selectedProcId, false)); // onlyVoucher = false -> Cancel Entire Process
    setCancelModalAccepted(false);
  };

  const cancelProcessServiceAccepted = selectedProcId => {
    dispatch(cancelAcceptedProcessInstance(selectedProcId, true)); // onlyVoucher = true -> Cancel only Voucher Service
    setCancelModalServiceAccepted(false);
  };

  const unassignProcessService = selectedProcId => {
    dispatch(unassignProcessInstanceExtended(selectedProcId));
    setUnassignModalService(false);
  };

  const voucherClear = () => {
    setVoucherError(false);
    dispatch(setVoucherErrorDescription());
  };

  const releaseApplicationClear = () => {
    setReleaseApplicationErrorModal(false);
    dispatch(setReleaseApplicationErrorDescription());
  };

  const releaseEquipment = voucherEquipmentNumber => {
    dispatch(releaseApplication(voucherEquipmentNumber));
    setReleaseEquipmentModal(false);
  };

  const releaseService = voucherServiceNumber => {
    dispatch(releaseApplication(voucherServiceNumber));
    setReleaseServiceModal(false);
  };

  const filterText = isFiltersVisible ? 'filterText' : 'filterTextDefault';

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: record => {
      return {
        disabled:
          record.applStatus !== 'AS_1G' && record.applStatus !== 'AS_6B',
      };
    },
  };

  useEffect(() => {
    if (groups !== 'undefined') {
      if (
        !isEmpty(detailedPayload) &&
        userStatus &&
        !isSupplier(groups) &&
        !isVoucherAuditor(groups) &&
        !isVoucherViewer(groups) &&
        !refreshKey
      ) {
        setCurrentPage(1);
        dispatch(
          fetchProcInstancesDetailedPaginated(detailedPayload, 1, pageSizeFlag)
        );
      } else if (isSupplier(groups) && !isEmpty(detailedPayload)) {
        setCurrentPage(1);
        dispatch(
          fetchProcInstancesSupplierPaginated(detailedPayload, 1, pageSizeFlag)
        );
        dispatch(fetchVoucherStatuses());
      } else if (isVoucherViewer(groups) && !isEmpty(detailedPayload)) {
        setCurrentPage(1);

        dispatch(
          fetchProcInstancesVoucherViewerPaginated(
            detailedPayload,
            1,
            pageSizeFlag,
            afmField || null,
            voucherNumber || null
          )
        );
        dispatch(fetchVoucherStatusesVoucherViewer());
      } else if (isVoucherAuditor(groups) && !isEmpty(detailedPayload)) {
        setCurrentPage(1);
        dispatch(
          fetchProcInstancesVoucherAuditorPaginated(
            detailedPayload,
            1,
            pageSizeFlag
          )
        );
      } else if (isBeneficiary(groups) && refreshKey > 0) {
        dispatch(
          fetchProcInstancesDetailedPaginated(
            detailedPayload,
            currentPage,
            pageSizeFlag
          )
        );
      }
    }
  }, [detailedPayload, groups, refreshKey]);

  const formatter = new Intl.NumberFormat('el-GR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  });

  const saytOptionsTmp = [];

  const handleSAYT = value => {
    //   if (value.length >= 3) {
    //     dispatch(fetchProcessSAYT(value));
    // };
  };

  useEffect(() => {
    if (sayt && !isEmpty(sayt)) {
      Object.values(sayt).map(key => {
        const opt = { options: [] };
        if (key?.name != 'limitExceeded') {
          if (key?.name == 'abiVat' || key?.name == 'legalVat') {
            opt.label = renderTitle('Α.Φ.Μ.');
          } else if (key?.name == 'businessKey') {
            opt.label = renderTitle('Αρ Αίτησης');
          } else if (key?.name == 'companyName') {
            opt.label = renderTitle('Επωνυμία');
          }
          const uniqueValues = new Set();

          for (let value of key?.values) {
            if (!uniqueValues.has(value.value)) {
              uniqueValues.add(value.value);
              opt.options.push(renderItem(value.value));
            }
          }
          saytOptionsTmp.push(opt);
        }
        setSaytOptions(saytOptionsTmp);
      });
    } else {
      setSaytOptions([]);
    }
  }, [sayt]);

  const prefix = <SearchIcon style={{ marginRight: '14px' }} />;

  const onSAYTSelect = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    // detailedPayloadTmp["saytKey"] = value;
    // setDetailedPayload(detailedPayloadTmp);
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('sayt'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'sayt') {
            return {
              ...obj,
              value: value,
            };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'sayt',
          type: 'STRING_VALUE',
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSAYTSearch = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('sayt'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'sayt') {
            return {
              ...obj,
              value: value,
            };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'sayt',
          type: 'STRING_VALUE',
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSAYTChange = value => {
    if (value.length == 0) {
      dispatch(clearSayt());
      setSaytOptions([]);
      const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
      // delete detailedPayloadTmp.saytKey;
      // setDetailedPayload(detailedPayloadTmp);
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onStatusChange = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    // console.log(detailedPayloadTmp, value)
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('activeTaskName'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'activeTaskName') {
            return { ...obj, value: [value] };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'activeTaskName',
          type: 'STRING_LIST',
          value: [value],
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'activeTaskName'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onStatusChangeVoucher = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    if (!isNil(value)) {
      detailedPayloadTmp.parameterList = [];
      detailedPayloadTmp.parameterList.push({
        qualifier: 'status',
        type: 'STRING_VALUE',
        value: value,
      });
      setDetailedPayload(detailedPayloadTmp);
    } else {
      detailedPayloadTmp.parameterList = [];
      setDetailedPayload(detailedPayloadTmp);
      dispatch(
        fetchProcInstancesSupplierPaginated(detailedPayloadTmp, 1, pageSizeFlag)
      );
    }
  };

  const onStatusChangeVoucherViewer = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    if (!isNil(value)) {
      detailedPayloadTmp.parameterList = [];
      detailedPayloadTmp.parameterList.push({
        qualifier: 'status',
        type: 'STRING_VALUE',
        value: value,
      });
      setDetailedPayload(detailedPayloadTmp);
    } else {
      detailedPayloadTmp.parameterList = [];
      setDetailedPayload(detailedPayloadTmp);
      detailedPayloadTmp.vatId = afmField || null;
      detailedPayloadTmp.voucherNumber = voucherNumber || null;
      dispatch(
        fetchProcInstancesVoucherViewerPaginated(
          detailedPayloadTmp,
          1,
          pageSizeFlag
        )
      );
    }
  };

  const onFilterChange = (value, qualifier, type) => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes(qualifier))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === qualifier) {
            return {
              ...obj,
              value: value,
            };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: qualifier,
          type: type,
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== qualifier
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onDateRangeChange = (value, dateString) => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      if (!isEmpty(dateString[0]) && !isEmpty(dateString[1])) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'submission_date') {
            return {
              ...obj,
              from: dateString[0],
              to: dateString[1],
            };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'submission_date',
          type: 'RANGE_DATE',
          from: dateString[0],
          to: dateString[1],
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'submission_date'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSliderChange = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      if (!isEmpty(value[0]) && !isEmpty(value[1])) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'totalValue') {
            return {
              ...obj,
              from: value[0],
              to: value[1],
            };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'totalValue',
          type: 'RANGE_VALUE',
          from: value[0],
          to: value[1],
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'totalValue'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const id = open ? 'simple-popover' : 'simple-popover';

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(checkUser(navigate));
    }, process.env.REACT_APP_SESSION_CHECK_TIME);
    return () => clearInterval(intervalId);
  }, []);

  const onMoreClick = (id, b_key, record) => event => {
    setSelectedProcId(id);
    setVoucherEquipmentNumber(record?.voucherEquipmentNumber);
    setVoucherServiceNumber(record?.voucherServiceNumber);
    dispatch(setActiveFormId(id));
    // setSelectedBusinessKey(b_key);
    // setSelectedBusKey(b_key);
    setAnchorEl(event.currentTarget);
    setOpen(true);
    // setUsers([]);
    // setSelectedUser(null);
    // setAssignDisabled(false);
  };

  const onMoreClickVoucher = (id, code) => event => {
    setSelectedProcId(id);
    dispatch(setActiveFormId(id));
    setSelectedVoucher(code);
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const onMoreClickVoucherAuditor = (id, code, supplierVat) => event => {
    setSelectedProcId(id);
    dispatch(setActiveFormId(id));
    setSelectedVoucher(code);
    setSelectedSupplierVat(supplierVat);
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const getStatusTag = status => {
    switch (status) {
      //Υποβολή Αίτησης
      case 'task.name.application_submission':
        return getLocalString(
          locales,
          localNames.TASK_NAME_APPLICATION_SUBMISSION
        );
      //Επιστροφή στον Ωφελούμενο
      case 'task.name.application_returned_to_beneficiary':
        return 'Επιστροφή στον Ωφελούμενο';
      //Αξιολόγηση Αίτησης
      case 'task.name.application_evaluation':
        return getLocalString(
          locales,
          localNames.TASK_NAME_APPLICATION_EVALUATION
        );
      //Απόρριψη
      case 'task.name.temporary_rejected':
        return getLocalString(
          locales,
          localNames.TASK_NAME_APPLICATION_REJECTED
        );
      //Υποβολή Αξιολόγησης
      case 'task.name.accepted':
        return getLocalString(
          locales,
          localNames.TASK_NAME_APPLICATION_ACCEPTED
        );
      //Προς Αξιολόγηση από Επιτροπή
      case 'task.name.application_evaluation_before_committee':
        return getLocalString(
          locales,
          localNames.TASK_NAME__APPLICATION_EVALUATION_BEFORE_COMMITTEE
        );
      //Εκδοση προσωρινής Κατάταξης
      case 'task.name.issuance_of_provisional_classification':
        return getLocalString(
          locales,
          localNames.TASK_NAME_ISSUANCE_OF_PROVISIONAL_CLASSIFICATION
        );
      //Υποβολή Ένστασης
      case 'task.name.objection_submission':
        return getLocalString(
          locales,
          localNames.TASK_NAME_OBJECTION_SUBMISSION
        );
      //Αξιολόγηση ΕΕ
      case 'task.name.objection_evaluation':
        return getLocalString(
          locales,
          localNames.TASK_NAME_OBJECTION_EVALUATION
        );
      //Αξιολόγηση Ενστάσεων - Απόρριψη Ένστασης
      case 'task.name.application_rejection':
        return getLocalString(
          locales,
          localNames.TASK_NAME_APPLICATION_REJECTION
        );
      //Εκδοση τελικής Κατάταξης
      case 'task.name.final_classification':
        return getLocalString(
          locales,
          localNames.TASK_NAME_FINAL_CLASSIFICATION
        );
      //ακύρωση Αίτησης
      case 'task.name.cancel':
        return getLocalString(locales, localNames.TASK_NAME_CANCEL);
      case 'task.name.program_implementation':
        return getLocalString(
          locales,
          localNames.REQUEST_STATUS_PROGRAMIMPLEMENTATION
        );
      default:
        return null;
    }
  };

  const beneficiaryColumns = [
    {
      title: 'Αριθμός Αίτησης',
      dataIndex: 'businessKey',
      key: 'businessKey',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.businessKey}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => a.businessKey - b.businessKey,
      },
      width: 120,
      fixed: 'left',
    },
    {
      title: 'Αριθμός Παροχής',
      dataIndex: 'powerNumberBuilding',
      key: 'powerNumberBuilding',
      render: (text, record) => {
        return (
          <TableCell
            id={`powerNumberBuilding-cell-${record.powerNumberBuilding}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          const numA = parseFloat(a.powerNumberBuilding) || 0;
          const numB = parseFloat(b.powerNumberBuilding) || 0;
          return numA - numB;
        },
      },
      width: 160,
      minWidth: 160,
      fixed: 'left',
    },
    {
      title: 'Διεύθυνση κτιρίου',
      dataIndex: 'buildStreetBuilding',
      key: 'buildStreetBuilding',
      render: text => <TableCell text={text} />,
      className: 'col-3',
      width: 260,
    },
    {
      title: 'Περιοχή',
      dataIndex: 'abiDistrictBuilding',
      key: 'abiDistrictBuilding',
      render: text => <TableCell text={text} />,
      className: 'col-3',
      width: 260,
    },
    {
      title: 'Status',
      dataIndex: 'activeTaskName',
      key: 'activeTaskName',
      render: (text, record) => {
        return (
          <StatusTag
            id={`activeTaskName-cell-${record.businessKey}`}
            status={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          if (
            typeof getStatusTag(a.activeTaskName) === 'string' &&
            typeof getStatusTag(b.activeTaskName) === 'string'
          ) {
            return getStatusTag(a.activeTaskName).localeCompare(
              getStatusTag(b.activeTaskName)
            );
          }
          if (
            typeof getStatusTag(a.activeTaskName) !== 'string' &&
            typeof getStatusTag(b.activeTaskName) === 'string'
          ) {
            return -1;
          }
          if (
            typeof getStatusTag(a.activeTaskName) === 'string' &&
            typeof getStatusTag(b.activeTaskName) !== 'string'
          ) {
            return 1;
          }
          return 0;
        },
      },
      className: 'col-2',
      width: 180,
    },
    {
      title: 'Voucher Εξοπλισμού',
      dataIndex: 'voucherEquipmentNumber',
      key: 'voucherEquipmentNumber',
      fixed: 'center',
      align: 'center',
      render: (text, record) => {
        const equipmentVoucherNumber = record?.voucherEquipmentNumber
          ? record?.voucherEquipmentStatus === 'CANCELED'
            ? 'Ακυρωμένο'
            : record?.voucherEquipmentNumber
          : '-';

        return (
          <>
            <TableCell
              id={`voucherEquipement-cell-${record?.voucherEquipmentNumber}`}
              text={equipmentVoucherNumber}
            />
            <StatusTag
              id={`activeTaskName-cell-${record?.voucherEquipmentNumber}`}
              status={record?.voucherEquipmentStatus}
            />
          </>
        );
      },
      sorter: {
        compare: (a, b) => {
          const valA = a.voucherEquipmentNumber ?? '';
          const valB = b.voucherEquipmentNumber ?? '';
          return valA.localeCompare(valB, 'el', { numeric: true });
        },
      },
      width: 140,
    },
    {
      title: 'Voucher Υπηρεσιών',
      dataIndex: 'voucherServiceNumber',
      key: 'voucherServiceNumber',
      fixed: 'center',
      align: 'center',
      render: (text, record) => {
        const serviceVoucherNumber = record?.voucherServiceNumber
          ? record?.voucherServiceStatus === 'CANCELED'
            ? 'Ακυρωμένο'
            : record?.voucherServiceNumber
          : '-';

        return (
          <>
            <TableCell
              id={`voucherServices-cell-${record.serviceVoucherNumber}`}
              text={serviceVoucherNumber}
            />
            <StatusTag
              id={`activeTaskName-cell-${record?.serviceVoucherNumber}`}
              status={record?.voucherServiceStatus}
            />
          </>
        );
      },
      sorter: {
        compare: (a, b) => {
          const valA = a.voucherServiceNumber ?? '';
          const valB = b.voucherServiceNumber ?? '';
          return valA.localeCompare(valB, 'el', { numeric: true });
        },
      },

      width: 140,
    },
    {
      title: 'Τύπος',
      dataIndex: 'equipmentType',
      key: 'equipmentType',
      render: (text, record) => {
        return (
          <TableCell
            text={
              !isNil(record?.equipmentType)
                ? record?.equipmentType == 'equipmentTypeThermosifonas'
                  ? 'Θερμοσίφωνας'
                  : 'Σύστημα Θέρμανσης'
                : '-'
            }
          />
        );
      },
      className: 'col-3',
      width: 200,
    },
    {
      title: 'Υποβολή',
      dataIndex: 'submissionDate',
      key: 'submissionDate',
      render: (text, record) => {
        return (
          <TableCell
            id={`submissionDate-cell-${record.businessKey}`}
            text={getFullDateTimeWithSeconds(text)}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          if (a.submissionDate && b.submissionDate) {
            return new Date(a.submissionDate) - new Date(b.submissionDate);
          } else if (!a.submissionDate && b.submissionDate) {
            return -1;
          } else if (a.submissionDate && !b.submissionDate) {
            return 1;
          } else {
            return 0;
          }
        },
      },
      width: 160,
    },
    {
      title: (
        <InfoMessage
          infoMessage={
            'Μπορείτε να εκτυπώσετε την παρούσα σελίδα και των αριθμών των επιταγών, πατώντας δεξί κλικ στο κενό, και μετά εκτύπωση (ή print)'
          }
          overlayClassName={'multiline-info-message'}
        />
      ),
      fixed: 'right',
      key: 'action',
      align: 'right',
      render: (text, record) => {
        return (
          <Space
            id={`action-cell-${record.businessKey}`}
            align="end"
            style={{ width: 'auto', marginRight: '2rem' }}
          >
            <Tooltip title="Actions">
              <ActionsIcon
                aria-describedby={id}
                onClick={e =>
                  onMoreClick(record.id, record.businessKey, record)(e)
                }
                style={{ cursor: 'pointer' }}
              />
            </Tooltip>
          </Space>
        );
      },
      width: 80,
    },
  ];

  const auditorColumns = [
    {
      title: 'Αριθμός Αίτησης',
      dataIndex: 'businessKey',
      key: 'businessKey',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.businessKey}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => a.businessKey - b.businessKey,
      },
      width: 120,
      fixed: 'left',
    },
    {
      title: 'Αριθμός Παροχής',
      dataIndex: 'powerNumberBuilding',
      key: 'powerNumberBuilding',
      render: (text, record) => {
        return (
          <TableCell
            id={`powerNumberBuilding-cell-${record.powerNumberBuilding}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          const numA = parseFloat(a.powerNumberBuilding) || 0;
          const numB = parseFloat(b.powerNumberBuilding) || 0;
          return numA - numB;
        },
      },
      width: 160,
      minWidth: 160,
      fixed: 'left',
    },
    {
      title: 'Διεύθυνση κτιρίου',
      dataIndex: 'buildStreetBuilding',
      key: 'buildStreetBuilding',
      render: text => <TableCell text={text} />,
      className: 'col-3',
      width: 260,
    },
    {
      title: 'Περιοχή',
      dataIndex: 'abiDistrictBuilding',
      key: 'abiDistrictBuilding',
      render: text => <TableCell text={text} />,
      className: 'col-3',
      width: 260,
    },
    {
      title: 'Status',
      dataIndex: 'activeTaskName',
      key: 'activeTaskName',
      render: (text, record) => {
        return (
          <StatusTag
            id={`activeTaskName-cell-${record.businessKey}`}
            status={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          if (
            typeof getStatusTag(a.activeTaskName) === 'string' &&
            typeof getStatusTag(b.activeTaskName) === 'string'
          ) {
            return getStatusTag(a.activeTaskName).localeCompare(
              getStatusTag(b.activeTaskName)
            );
          }
          if (
            typeof getStatusTag(a.activeTaskName) !== 'string' &&
            typeof getStatusTag(b.activeTaskName) === 'string'
          ) {
            return -1;
          }
          if (
            typeof getStatusTag(a.activeTaskName) === 'string' &&
            typeof getStatusTag(b.activeTaskName) !== 'string'
          ) {
            return 1;
          }
          return 0;
        },
      },
      className: 'col-2',
      width: 180,
    },
    {
      title: 'Voucher Εξοπλισμού',
      dataIndex: 'voucherEquipmentNumber',
      key: 'voucherEquipmentNumber',
      render: (text, record) => {
        const equipmentVoucherNumber = record?.voucherEquipmentNumber
          ? record?.voucherEquipmentStatus === 'CANCELED'
            ? 'Ακυρωμένο'
            : record?.voucherEquipmentNumber
          : '-';

        return (
          <TableCell
            id={`voucherEquipement-cell-${record.voucherEquipement}`}
            text={equipmentVoucherNumber}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          const valA = a.voucherEquipmentNumber ?? '';
          const valB = b.voucherEquipmentNumber ?? '';
          return valA.localeCompare(valB, 'el', { numeric: true });
        },
      },
      width: 140,
      fixed: 'left',
    },
    {
      title: 'Voucher Υπηρεσιών',
      dataIndex: 'voucherServiceNumber',
      key: 'voucherServiceNumber',
      render: (text, record) => {
        const serviceVoucherNumber = record?.voucherServiceNumber
          ? record?.voucherServiceStatus === 'CANCELED'
            ? 'Ακυρωμένο'
            : record?.voucherServiceNumber
          : '-';

        return (
          <TableCell
            id={`voucherServices-cell-${record.serviceVoucherNumber}`}
            text={serviceVoucherNumber}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          const valA = a.voucherServiceNumber ?? '';
          const valB = b.voucherServiceNumber ?? '';
          return valA.localeCompare(valB, 'el', { numeric: true });
        },
      },
      width: 140,
      fixed: 'left',
    },
    {
      title: 'Τύπος',
      dataIndex: 'equipmentType',
      key: 'equipmentType',
      render: (text, record) => {
        return (
          <TableCell
            text={
              !isNil(record?.equipmentType)
                ? record?.equipmentType == 'equipmentTypeThermosifonas'
                  ? 'Θερμοσίφωνας'
                  : 'Σύστημα Θέρμανσης'
                : '-'
            }
          />
        );
      },
      className: 'col-3',
      width: 200,
    },
    {
      title: 'Αξιολογητής',
      dataIndex: 'evaluator',
      key: 'evaluator',
      render: (text, record) => {
        return (
          <TableCell
            id={`evaluator-cell-${record.businessKey}`}
            text={record?.evaluator || '-'}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          const evaluatorA = a.evaluator || '';
          const evaluatorB = b.evaluator || '';
          return evaluatorA.localeCompare(evaluatorB);
        },
      },
      className: 'col-3',
      width: 180,
    },
    {
      title: 'Προμηθευτής',
      dataIndex: 'supplier',
      key: 'supplier',
      render: text => <TableCell text={text} />,
      className: 'col-3',
      width: 200,
    },
    {
      title: 'Υποβολή',
      dataIndex: 'submissionDate',
      key: 'submissionDate',
      render: (text, record) => {
        return (
          <TableCell
            id={`submissionDate-cell-${record.businessKey}`}
            text={getFullDateTimeWithSeconds(text)}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          if (a.submissionDate && b.submissionDate) {
            return new Date(a.submissionDate) - new Date(b.submissionDate);
          } else if (!a.submissionDate && b.submissionDate) {
            return -1;
          } else if (a.submissionDate && !b.submissionDate) {
            return 1;
          } else {
            return 0;
          }
        },
      },
      width: 160,
    },
    {
      title: '',
      fixed: 'right',
      key: 'action',
      align: 'right',
      render: (text, record) => {
        return (
          <Space
            id={`action-cell-${record.businessKey}`}
            align="end"
            style={{ width: 'auto', marginRight: '2rem' }}
          >
            <Tooltip title="Actions">
              <ActionsIcon
                aria-describedby={id}
                onClick={e => onMoreClick(record.id, record.businessKey)(e)}
                style={{ cursor: 'pointer' }}
              />
            </Tooltip>
          </Space>
        );
      },
      width: 80,
    },
  ];

  const suppplierColumns = [
    {
      title: 'Αριθμός Αίτησης',
      dataIndex: 'applicationNumber',
      key: 'applicationNumber',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.applicationNumber}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => a.applicationNumber - b.applicationNumber,
      },
      width: 120,
      fixed: 'left',
    },
    {
      title: 'Α.Φ.Μ',
      dataIndex: 'legalVat',
      key: 'legalVat',
      render: (text, record) => {
        return (
          <TableCell
            id={`powerNumberBuilding-cell-${record.legalVat}`}
            text={text}
          />
        );
      },
      width: 160,
      minWidth: 160,
      fixed: 'left',
    },
    {
      title: 'Αριθμός Voucher',
      dataIndex: 'code',
      key: 'code',
      render: text => <TableCell text={text} />,
      className: 'col-3',
      width: 260,
    },
    {
      title: 'Ονοματεπώνυμο',
      dataIndex: 'legalName',
      key: 'legalName',
      render: text => <TableCell text={text} />,
      className: 'col-3',
      width: 260,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => {
        return (
          <StatusTag
            id={`activeTaskName-cell-${record.businessKey}`}
            status={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          if (
            typeof getStatusTag(a.activeTaskName) === 'string' &&
            typeof getStatusTag(b.activeTaskName) === 'string'
          ) {
            return getStatusTag(a.activeTaskName).localeCompare(
              getStatusTag(b.activeTaskName)
            );
          }
          if (
            typeof getStatusTag(a.activeTaskName) !== 'string' &&
            typeof getStatusTag(b.activeTaskName) === 'string'
          ) {
            return -1;
          }
          if (
            typeof getStatusTag(a.activeTaskName) === 'string' &&
            typeof getStatusTag(b.activeTaskName) !== 'string'
          ) {
            return 1;
          }
          return 0;
        },
      },
      className: 'col-2',
      width: 180,
    },
    {
      title: 'Τύπος Voucher',
      dataIndex: 'type',
      key: 'type',
      render: (text, record) => {
        return <TableCell text={!isNil(record?.type) ? record?.type : '-'} />;
      },
      sorter: {
        compare: (a, b) =>
          (a.type || '')
            .toLowerCase()
            .localeCompare((b.type || '').toLowerCase(), 'el'),
      },
      width: 140,
    },
    {
      title: 'Υπαγωγή',
      dataIndex: 'numberAffiliation',
      key: 'numberAffiliation',
      fixed: 'center',
      align: 'center',
      render: (text, record) => {
        return (
          <TableCell
            text={
              !isNil(record?.numberAffiliation)
                ? record?.numberAffiliation
                : '-'
            }
          />
        );
      },
      sorter: {
        compare: (a, b) =>
          (a.numberAffiliation || '')
            .toLowerCase()
            .localeCompare((b.numberAffiliation || '').toLowerCase(), 'el'),
      },
      width: 140,
    },
    {
      title: 'Περιοχή',
      dataIndex: 'abiDistrict',
      key: 'abiDistrict',
      render: text => <TableCell text={text} />,
      className: 'col-3',
      width: 260,
    },
    ...(isSupplier(groups) || isVoucherViewer(groups)
      ? [
          {
            title: 'Ποσοστό Επιδότησης',
            dataIndex: 'discountPercentage',
            key: 'discountPercentage',
            render: value => (
              <TableCell text={value != null ? `${value}%` : '-'} />
            ),
            className: 'col-3',
            width: 260,
          },
        ]
      : [
          {
            title: 'Νομός',
            dataIndex: 'abiPrefecture',
            key: 'abiPrefecture',
            render: text => <TableCell text={text} />,
            className: 'col-3',
            width: 260,
          },
        ]),
    {
      title: 'Ημερομηνία',
      dataIndex: 'issueDate',
      key: 'issueDate',
      render: (text, record) => {
        return (
          <TableCell
            id={`submissionDate-cell-${record.issueDate}`}
            text={getFullDateTimeWithSeconds(text)}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          if (a.issueDate && b.issueDate) {
            return new Date(a.issueDate) - new Date(b.issueDate);
          } else if (!a.issueDate && b.issueDate) {
            return -1;
          } else if (a.issueDate && !b.issueDate) {
            return 1;
          } else {
            return 0;
          }
        },
      },
      width: 160,
    },
    {
      title: '',
      fixed: 'right',
      key: 'action',
      align: 'right',
      render: (text, record) => {
        return (
          <Space
            id={`action-cell-${record.code}`}
            align="end"
            style={{ width: 'auto', marginRight: '2rem' }}
          >
            <Tooltip title="Actions">
              <ActionsIcon
                aria-describedby={id}
                onClick={e =>
                  onMoreClickVoucher(record.processInstanceId, record.code)(e)
                }
                style={{ cursor: 'pointer' }}
              />
            </Tooltip>
          </Space>
        );
      },
      width: 80,
    },
  ];

  const voucherAuditorColumns = [
    {
      title: 'Αριθμός Αίτησης',
      dataIndex: 'applicationNumber',
      key: 'applicationNumber',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.applicationNumber}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => a.applicationNumber - b.applicationNumber,
      },
      width: 120,
      fixed: 'left',
    },
    {
      title: 'Α.Φ.Μ',
      dataIndex: 'legalVat',
      key: 'legalVat',
      render: (text, record) => {
        return (
          <TableCell
            id={`powerNumberBuilding-cell-${record.legalVat}`}
            text={text}
          />
        );
      },
      width: 160,
      minWidth: 160,
      fixed: 'left',
    },
    {
      title: 'Αριθμός Voucher',
      dataIndex: 'code',
      key: 'code',
      render: text => <TableCell text={text} />,
      className: 'col-3',
      width: 260,
    },
    {
      title: 'Ονοματεπώνυμο Ωφελούμενου',
      dataIndex: 'legalName',
      key: 'legalName',
      render: text => <TableCell text={text} />,
      className: 'col-3',
      width: 260,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => {
        return (
          <StatusTag
            id={`activeTaskName-cell-${record.businessKey}`}
            status={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          if (
            typeof getStatusTag(a.activeTaskName) === 'string' &&
            typeof getStatusTag(b.activeTaskName) === 'string'
          ) {
            return getStatusTag(a.activeTaskName).localeCompare(
              getStatusTag(b.activeTaskName)
            );
          }
          if (
            typeof getStatusTag(a.activeTaskName) !== 'string' &&
            typeof getStatusTag(b.activeTaskName) === 'string'
          ) {
            return -1;
          }
          if (
            typeof getStatusTag(a.activeTaskName) === 'string' &&
            typeof getStatusTag(b.activeTaskName) !== 'string'
          ) {
            return 1;
          }
          return 0;
        },
      },
      className: 'col-2',
      width: 180,
    },
    {
      title: 'Τύπος Voucher',
      dataIndex: 'type',
      key: 'type',
      render: (text, record) => {
        return <TableCell text={!isNil(record?.type) ? record?.type : '-'} />;
      },
      sorter: {
        compare: (a, b) =>
          (a.type || '')
            .toLowerCase()
            .localeCompare((b.type || '').toLowerCase(), 'el'),
      },
      width: 140,
    },
    {
      title: 'Περιοχή',
      dataIndex: 'abiDistrict',
      key: 'abiDistrict',
      render: text => <TableCell text={text} />,
      className: 'col-3',
      width: 260,
    },
    {
      title: 'Νομός',
      dataIndex: 'abiPrefecture',
      key: 'abiPrefecture',
      render: text => <TableCell text={text} />,
      className: 'col-3',
      width: 260,
    },
    {
      title: 'Α.Φ.Μ Προμηθευτή',
      dataIndex: 'supplierVat',
      key: 'supplierVat',
      render: text => <TableCell text={text} />,
      className: 'col-3',
      width: 260,
    },
    {
      title: 'Status Αξιολόγησης',
      dataIndex: 'auditStatus',
      key: 'auditStatus',
      render: (text, record) => {
        return (
          <StatusTag
            id={`activeTaskName-cell-${record.businessKey}`}
            status={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          if (
            typeof getStatusTag(a.auditStatus) === 'string' &&
            typeof getStatusTag(b.auditStatus) === 'string'
          ) {
            return getStatusTag(a.auditStatus).localeCompare(
              getStatusTag(b.auditStatus)
            );
          }
          if (
            typeof getStatusTag(a.auditStatus) !== 'string' &&
            typeof getStatusTag(b.auditStatus) === 'string'
          ) {
            return -1;
          }
          if (
            typeof getStatusTag(a.auditStatus) === 'string' &&
            typeof getStatusTag(b.auditStatus) !== 'string'
          ) {
            return 1;
          }
          return 0;
        },
      },
      className: 'col-2',
      width: 180,
    },
    {
      title: 'Υπαγωγή',
      dataIndex: 'numberAffiliation',
      key: 'numberAffiliation',
      fixed: 'center',
      align: 'center',
      render: (text, record) => {
        return (
          <TableCell
            text={
              !isNil(record?.numberAffiliation)
                ? record?.numberAffiliation
                : '-'
            }
          />
        );
      },
      sorter: {
        compare: (a, b) =>
          (a.numberAffiliation || '')
            .toLowerCase()
            .localeCompare((b.numberAffiliation || '').toLowerCase(), 'el'),
      },
      width: 140,
    },
    {
      title: 'Ημερομηνία',
      dataIndex: 'issueDate',
      key: 'issueDate',
      render: (text, record) => {
        return (
          <TableCell
            id={`submissionDate-cell-${record.issueDate}`}
            text={getFullDateTimeWithSeconds(text)}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          if (a.issueDate && b.issueDate) {
            return new Date(a.issueDate) - new Date(b.issueDate);
          } else if (!a.issueDate && b.issueDate) {
            return -1;
          } else if (a.issueDate && !b.issueDate) {
            return 1;
          } else {
            return 0;
          }
        },
      },
      width: 160,
    },
    {
      title: '',
      fixed: 'right',
      key: 'action',
      align: 'right',
      render: (text, record) => {
        return (
          <Space
            id={`action-cell-${record.code}`}
            align="end"
            style={{ width: 'auto', marginRight: '2rem' }}
          >
            <Tooltip title="Actions">
              <ActionsIcon
                aria-describedby={id}
                onClick={e =>
                  onMoreClickVoucherAuditor(
                    record.processInstanceId,
                    record.code,
                    record.supplierVat
                  )(e)
                }
                style={{ cursor: 'pointer' }}
              />
            </Tooltip>
          </Space>
        );
      },
      width: 80,
    },
  ];

  const [sortedUp, setSortedUp] = useState(false);
  const [sortedDown, setSortedDown] = useState(true);

  return loadingTaxis || loadingLocales ? (
    <div className="custom-spinner">
      <div>
        <Spin size="large" />
      </div>
    </div>
  ) : (
    <main>
      <Modal
        id={`cancel-modal-${selectedProcId}`}
        centered
        width={400}
        open={cancelModal}
        className={`custom-modal`}
        onCancel={() => setCancelModal(false)}
        onOk={() => setCancelModal(false)}
        closable={false}
        footer={null}
      >
        <div className="image_modal">
          <CancelWarningIcon />
        </div>
        <div className="modal_info">
          <h3>Επιβεβαίωση Ακύρωσης Αίτησης</h3>
          <p>
            Είστε σίγουροι ότι επιθυμείτε να ακυρώσετε την συγκεκριμένη αίτηση;
          </p>
          <p>Προσοχή η ενέργεια είναι μη αναστρέψιμη.</p>
        </div>
        <div className="footerBtnContainer">
          <div
            id={'cancel-modal-cancel-button'}
            className="cancel-btn-assign"
            onClick={() => setCancelModal(false)}
          >
            Επιστροφή
          </div>
          <div
            id={`cancel-modal-ok-button-${selectedProcId}`}
            onClick={() => cancelProcess(selectedProcId)}
            className="btn-assign"
          >
            Επιβεβαίωση
          </div>
        </div>
      </Modal>

      <Modal
        id={`cancel-modal-${selectedProcId}`}
        centered
        width={400}
        open={cancelModalEquipment}
        className={`custom-modal`}
        onCancel={() => setCancelModalEquipment(false)}
        onOk={() => setCancelModalEquipment(false)}
        closable={false}
        footer={null}
      >
        <div className="image_modal">
          <CancelWarningIcon />
        </div>
        <div className="modal_info">
          <h3>Επιβεβαίωση Ακύρωσης Voucher Εξοπλισμού</h3>
          <p>
            Είστε σίγουροι ότι επιθυμείτε να ακυρώσετε το Voucher Εξοπλισμού;
          </p>
          <p>
            Αν ναι, τότε θα πρέπει να γνωρίζετε οτι θα ακυρωθεί αυτόματα και η
            Αίτηση.
          </p>
          <p>Προσοχή η ενέργεια είναι μη αναστρέψιμη.</p>
        </div>
        <div className="footerBtnContainer">
          <div
            id={'cancel-modal-cancel-button'}
            className="cancel-btn-assign"
            onClick={() => setCancelModalEquipment(false)}
          >
            Επιστροφή
          </div>
          <div
            id={`cancel-modal-ok-button-${selectedProcId}`}
            onClick={() => cancelProcessEquipment(selectedProcId)}
            className="btn-assign"
          >
            Επιβεβαίωση
          </div>
        </div>
      </Modal>

      <Modal
        id={`cancel-modal-${selectedProcId}`}
        centered
        width={400}
        open={cancelModalService}
        className={`custom-modal`}
        onCancel={() => setCancelModalService(false)}
        onOk={() => setCancelModalService(false)}
        closable={false}
        footer={null}
      >
        <div className="image_modal">
          <CancelWarningIcon />
        </div>
        <div className="modal_info">
          <h3>Επιβεβαίωση Ακύρωσης Voucher Υπηρεσιών</h3>
          <p>
            Είστε σίγουροι ότι επιθυμείτε να ακυρώσετε το Voucher Υπηρεσιών;
          </p>
          <p>Προσοχή η ενέργεια είναι μη αναστρέψιμη.</p>
        </div>
        <div className="footerBtnContainer">
          <div
            id={'cancel-modal-cancel-button'}
            className="cancel-btn-assign"
            onClick={() => setCancelModalService(false)}
          >
            Επιστροφή
          </div>
          <div
            id={`cancel-modal-ok-button-${selectedProcId}`}
            onClick={() => cancelProcessService(selectedProcId)}
            className="btn-assign"
          >
            Επιβεβαίωση
          </div>
        </div>
      </Modal>

      {/* Cancel ENTIRE process in status ACCEPTED */}
      <Modal
        id={`cancel-modal-${selectedProcId}`}
        centered
        width={400}
        open={cancelModalAccepted}
        className={`custom-modal`}
        onCancel={() => setCancelModalAccepted(false)}
        onOk={() => setCancelModalAccepted(false)}
        closable={false}
        footer={null}
      >
        <div className="image_modal">
          <CancelWarningIcon />
        </div>
        <div className="modal_info">
          <h3>Επιβεβαίωση Ακύρωσης Αίτησης</h3>
          <p>
            Είστε σίγουροι ότι επιθυμείτε να ακυρώσετε την συγκεκριμένη αίτηση;
          </p>
          <p>Προσοχή η ενέργεια είναι μη αναστρέψιμη.</p>
        </div>
        <div className="footerBtnContainer">
          <div
            id={'cancel-modal-cancel-button'}
            className="cancel-btn-assign"
            onClick={() => setCancelModalAccepted(false)}
          >
            Επιστροφή
          </div>
          <div
            id={`cancel-modal-ok-button-${selectedProcId}`}
            onClick={() => cancelProcessAccepted(selectedProcId)}
            className="btn-assign"
          >
            Επιβεβαίωση
          </div>
        </div>
      </Modal>

      {/* Cancel SERVICE VOUCHER in status ACCEPTED */}
      <Modal
        id={`cancel-modal-${selectedProcId}`}
        centered
        width={400}
        open={cancelModalServiceAccepted}
        className={`custom-modal`}
        onCancel={() => setCancelModalServiceAccepted(false)}
        onOk={() => setCancelModalServiceAccepted(false)}
        closable={false}
        footer={null}
      >
        <div className="image_modal">
          <CancelWarningIcon />
        </div>
        <div className="modal_info">
          <h3>Επιβεβαίωση Ακύρωσης Voucher Υπηρεσιών</h3>
          <p>
            Είστε σίγουροι ότι επιθυμείτε να ακυρώσετε το Voucher Υπηρεσιών;
          </p>
          <p>Προσοχή η ενέργεια είναι μη αναστρέψιμη.</p>
        </div>
        <div className="footerBtnContainer">
          <div
            id={'cancel-modal-cancel-button'}
            className="cancel-btn-assign"
            onClick={() => setCancelModalServiceAccepted(false)}
          >
            Επιστροφή
          </div>
          <div
            id={`cancel-modal-ok-button-${selectedProcId}`}
            onClick={() => cancelProcessServiceAccepted(selectedProcId)}
            className="btn-assign"
          >
            Επιβεβαίωση
          </div>
        </div>
      </Modal>

      <Modal
        id={`unassign-modal-${selectedProcId}`}
        centered
        width={400}
        open={voucherError}
        className={`custom-modal`}
        onOk={() => setVoucherError(false)}
        closable={false}
        footer={null}
      >
        <div className="image_modal">
          <CancelWarningIcon />
        </div>
        <div className="modal_info">{voucherErrorMessage}</div>
        <div className="footerBtnContainer">
          <div
            id={`cancel-modal-ok-button-${selectedProcId}`}
            onClick={() => voucherClear()}
            className="btn-assign"
          >
            Επιβεβαίωση
          </div>
        </div>
      </Modal>
      <Modal
        id={`unassign-modal-${selectedProcId}`}
        centered
        width={400}
        open={unassignModalService}
        className={`custom-modal`}
        onCancel={() => setUnassignModalService(false)}
        onOk={() => setUnassignModalService(false)}
        closable={false}
        footer={null}
      >
        <div className="image_modal">
          <CancelWarningIcon />
        </div>
        <div className="modal_info">
          <h3>Επιβεβαίωση Ανάθεσης σε άλλον αξιολογητή</h3>
          <p>
            Είστε σίγουροι ότι επιθυμείτε να ανεθέσετε σε άλλον αξιολογητή την
            αίτηση;
          </p>
          <p>Προσοχή η ενέργεια είναι μη αναστρέψιμη.</p>
        </div>
        <div className="footerBtnContainer">
          <div
            id={'cancel-modal-cancel-button'}
            className="cancel-btn-assign"
            onClick={() => setUnassignModalService(false)}
          >
            Επιστροφή
          </div>
          <div
            id={`cancel-modal-ok-button-${selectedProcId}`}
            onClick={() => unassignProcessService(selectedProcId)}
            className="btn-assign"
          >
            Επιβεβαίωση
          </div>
        </div>
      </Modal>

      <Modal
        id={`release-modal-${selectedProcId}`}
        centered
        width={400}
        open={releaseEquipmentModal}
        className={`custom-modal`}
        onCancel={() => setReleaseEquipmentModal(false)}
        onOk={() => setReleaseEquipmentModal(false)}
        closable={false}
        footer={null}
      >
        <div className="image_modal">
          <CancelWarningIcon />
        </div>
        <div className="modal_info">
          <h3>Επιβεβαίωση Αποδέσμευσης Voucher Εξοπλισμού</h3>
          <p>
            Με την επιλογή σας θα ειδοποιηθεί ο προμηθευτής για την αποδέσμευση
            του παρόντος voucher. Η ενέργεια αυτή δεν είναι αναστρέψιμη.
            Επιθυμείτε να συνεχίσετε;
          </p>
        </div>
        <div className="footerBtnContainer">
          <div
            id={'cancel-modal-cancel-button'}
            className="cancel-btn-assign"
            onClick={() => setReleaseEquipmentModal(false)}
          >
            Επιστροφή
          </div>
          <div
            id={`cancel-modal-ok-button-${selectedProcId}`}
            onClick={() => releaseEquipment(voucherEquipmentNumber)}
            className="btn-assign"
          >
            Επιβεβαίωση
          </div>
        </div>
      </Modal>

      <Modal
        id={`release-modal-${selectedProcId}`}
        centered
        width={400}
        open={releaseServiceModal}
        className={`custom-modal`}
        onCancel={() => setReleaseServiceModal(false)}
        onOk={() => setReleaseServiceModal(false)}
        closable={false}
        footer={null}
      >
        <div className="image_modal">
          <CancelWarningIcon />
        </div>
        <div className="modal_info">
          <h3>Επιβεβαίωση Αποδέσμευσης Voucher Υπηρεσιών</h3>
          <p>
            Με την επιλογή σας θα ειδοποιηθεί ο προμηθευτής για την αποδέσμευση
            του παρόντος voucher. Η ενέργεια αυτή δεν είναι αναστρέψιμη.
            Επιθυμείτε να συνεχίσετε;
          </p>
        </div>
        <div className="footerBtnContainer">
          <div
            id={'cancel-modal-cancel-button'}
            className="cancel-btn-assign"
            onClick={() => setReleaseServiceModal(false)}
          >
            Επιστροφή
          </div>
          <div
            id={`cancel-modal-ok-button-${selectedProcId}`}
            onClick={() => releaseService(voucherServiceNumber)}
            className="btn-assign"
          >
            Επιβεβαίωση
          </div>
        </div>
      </Modal>

      <Modal
        id={`release-error-modal-${selectedProcId}`}
        centered
        width={400}
        open={releaseApplicationErrorModal}
        className={`custom-modal`}
        onOk={() => setReleaseApplicationErrorModal(false)}
        closable={false}
        footer={null}
      >
        <div className="image_modal">
          <CancelWarningIcon />
        </div>
        <div className="modal_info">
          {releaseApplicationError?.responseDescription
            ? releaseApplicationError?.responseDescription
            : 'Παρουσιάστηκε πρόβλημα. Παρακαλώ προσπαθήστε αργότερα.'}
        </div>
        <div className="footerBtnContainer">
          <div
            id={`cancel-modal-ok-button-${selectedProcId}`}
            onClick={() => releaseApplicationClear()}
            className="btn-assign"
          >
            Επιβεβαίωση
          </div>
        </div>
      </Modal>

      <div>
        <div>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
          >
            <ActionList
              open={setOpen}
              id={selectedProcId}
              payload={detailedPayload}
              voucher={selectedVoucher}
              supplierVat={selectedSupplierVat}
              voucherFlag={!isSupplier(groups) && !isVoucherViewer(groups)}
              voucherAuditor={isVoucherAuditor(groups)}
              voucherEquipmentNumber={voucherEquipmentNumber}
              voucherServiceNumber={voucherServiceNumber}
              setCancelModal={setCancelModal}
              setCancelModalService={setCancelModalService}
              setCancelModalAccepted={setCancelModalAccepted}
              setCancelModalServiceAccepted={setCancelModalServiceAccepted}
              setUnassignModalService={setUnassignModalService}
              setReleaseEquipmentModal={setReleaseEquipmentModal}
              setReleaseServiceModal={setReleaseServiceModal}
              refreshKey={refreshKey}
              setRefreshKey={setRefreshKey}
            />
          </Popover>
        </div>

        <div style={{ marginTop: '30px', marginBottom: '21px' }}>
          {privileges?.includes('CanRenderSAYT') && !isBeneficiary(groups) && (
            <div style={{ marginTop: '30px', marginBottom: '21px' }}>
              <AutoComplete
                popupClassName="certain-category-search-dropdown"
                dropdownMatchSelectWidth={500}
                style={{ width: '100%' }}
                options={saytOptions}
                onSearch={handleSAYT}
                onSelect={onSAYTSelect}
                onChange={onSAYTChange}
                defaultValue={detailedPayload?.saytKey}
              >
                <Input.Search
                  id="autocomplete-search-input"
                  onSearch={onSAYTSearch}
                  bordered={false}
                  allowClear={true}
                  prefix={prefix}
                  className="sayt-input-filter input-filter"
                  size="large"
                  // placeholder={getLocalString(
                  //   locales,
                  //   isKTP ? localNames.HOME_PAGE_SEARCHKTP :
                  //   isBeneficiary(groups) ? localNames.HOME_PAGE_SEARCHNP :
                  //   ''
                  // )}
                  placeholder="Αναζήτηση με Αρ. Αίτησης, ΑΦΜ, Όνομα, Επώνυμο, Επωνυμία, Α.Δ.Τ./Διαβατήριο, Διεύθυνση κτιρίου, Voucher"
                  enterButton
                />
              </AutoComplete>
            </div>
          )}

          {privileges?.includes('CanRenderAppFilters') && (
            <div>
              <Tooltip placement="right" title="Expanded Filters">
                <Space
                  id="filters-toggle-button"
                  onClick={() => toggleFilters()}
                  onMouseEnter={() => overFilter()}
                  onMouseLeave={() => outFilter()}
                  className="filterButton mt-3"
                >
                  {filterImg}
                  <span className={filterText}>
                    {getLocalString(
                      locales,
                      localNames.HOME_PAGE_FILTERSBUTTON
                    )}
                  </span>
                </Space>
              </Tooltip>

              {isFiltersVisible && (
                <div className="filtersContainer">
                  <div className="filters-wrapper">
                    <div style={{ flex: '1' }}>
                      <Select
                        id="select-application-status"
                        suffixIcon={<ArrowIcon />}
                        className="input-filter"
                        dropdownStyle={{ zIndex: 1050 }}
                        style={{ width: '100%', height: '3.02rem' }}
                        dropdownAlign={{ offset: [-11, 5] }}
                        allowClear={true}
                        placeholder={
                          getLocalString(
                            locales,
                            localNames?.HOME_PAGE_FILTERS_STATUS
                          ) || 'Status'
                        }
                        optionFilterProp="children"
                        onChange={onStatusChange}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {taskNames?.map(item => (
                          <Option
                            id={`status-${item.name}-option`}
                            key={item.name}
                            value={item.name}
                          >
                            {getLocalString(locales, item.name)}
                          </Option>
                        ))}
                      </Select>
                    </div>

                    <div style={{ flex: '1' }}>
                      <RangePicker
                        id="application-results-date-range-picker-from"
                        locale={{
                          ...locale,
                          lang: {
                            ...locale.lang,
                            rangePlaceholder: [
                              getLocalString(
                                locales,
                                localNames.HOME_PAGE_FILTERS_DATEFROM
                              ),
                              getLocalString(
                                locales,
                                localNames.HOME_PAGE_FILTERS_DATETO
                              ),
                            ],
                          },
                        }}
                        format={dateFormat}
                        suffixIcon={<CalendarIcon />}
                        allowEmpty={[true, true]}
                        onCalendarChange={onDateRangeChange}
                        className="input-filter"
                        style={{ width: '100%' }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          <Divider className="filter-divider" />
          {loadingPage && (
            <div className="custom-spinner">
              <div>
                <Spin
                  id="apptrack-application-results-table-spinner"
                  size="default"
                />
              </div>
            </div>
          )}
          {!loadingPage && (
            <Row gutter={32}>
              <Col span={24}>
                {!isEmpty(results) &&
                  (iniFlag === '1' || !isBeneficiary(groups)) &&
                  !isSupplier(groups) &&
                  !isVoucherAuditor(groups) &&
                  !isVoucherViewer(groups) && (
                    <div>
                      <Table
                        scroll={{ x: true }}
                        id="apptrack-application-results-table"
                        className="results-table"
                        dataSource={results}
                        columns={
                          isBeneficiary(user.groups)
                            ? beneficiaryColumns
                            : auditorColumns
                        }
                        rowKey="id"
                        pagination={{
                          total: resultSize,
                          current: currentPage,
                          showSizeChanger: true,
                          showTitle: true,
                          pageSizeOptions: [5, 10, 20, 50, 100, 200],
                          pageSize: pageSizeFlag,
                          onChange: (page, pageSize) => {
                            // console.log("page, pageSize",page,pageSize);
                            handlePageChange(page, pageSize);
                          },
                        }}
                      />
                    </div>
                  )}
                {(isSupplier(groups) || isVoucherViewer(groups)) && (
                  <div>
                    <Row>
                      <div className="input-filter-voucher">
                        <div className="input-wrapper" style={{ flex: 1 }}>
                          <Input
                            id="afm-search-input"
                            allowClear
                            value={afmField}
                            onChange={handleAfmChange}
                            prefix={prefix}
                            placeholder={
                              isVoucherViewer(groups)
                                ? 'Εισάγετε Α.Φ.Μ.'
                                : 'Εισάγετε Α.Φ.Μ. δικαιούχου'
                            }
                          />
                          {afmError && (
                            <div className="input-error">
                              Το πεδίο πρέπει να περιέχει ακριβώς 9 χαρακτήρες.
                            </div>
                          )}
                        </div>
                        <div className="input-wrapper" style={{ flex: 1 }}>
                          <Input
                            id="voucher-search-input"
                            allowClear
                            value={voucherNumber}
                            onChange={handleVoucherChange}
                            prefix={prefix}
                            placeholder="Εισάγετε Αριθμό Voucher"
                          />
                          {voucherNumberError && (
                            <div className="input-error">
                              Το πεδίο πρέπει να περιέχει ακριβώς 9 χαρακτήρες.
                            </div>
                          )}
                        </div>
                        <div id="search-voucher-wrapper">
                          <Button
                            id="search-voucher-button"
                            type="default"
                            className="ant-btn-primary"
                            label="Αναζήτηση"
                            disabled={(() => {
                              const isViewer = isVoucherViewer(groups);
                              const afmFilled =
                                !isNil(afmField) && afmField !== '';
                              const voucherFilled =
                                !isNil(voucherNumber) && voucherNumber !== '';
                              const afmValid =
                                !afmFilled || afmField.length === 9;
                              const voucherValid =
                                !voucherFilled || voucherNumber.length === 9;
                              // Supplier: BOTH required
                              if (!isViewer) {
                                return (
                                  !afmFilled ||
                                  !voucherFilled ||
                                  !afmValid ||
                                  !voucherValid
                                );
                              }
                              // VoucherViewer: either AFM or VoucherNumber
                              return (
                                !(afmFilled || voucherFilled) ||
                                !afmValid ||
                                !voucherValid
                              );
                            })()}
                            onClick={() => {
                              const vatId = afmField || null;
                              const vNumber = voucherNumber || null;
                              if (isVoucherViewer(groups)) {
                                dispatch(
                                  fetchProcInstancesVoucherViewerPaginated(
                                    detailedPayload,
                                    1,
                                    pageSizeFlag,
                                    vatId,
                                    vNumber
                                  )
                                );
                              } else {
                                dispatch(fetchVoucherByNuber(vatId, vNumber));
                              }
                            }}
                          />
                        </div>
                      </div>
                    </Row>
                    <Divider className="filter-divider" />
                    <Tooltip placement="right" title="Expanded Filters">
                      <Space
                        id="filters-toggle-button"
                        onClick={() => toggleFilters()}
                        onMouseEnter={() => overFilter()}
                        onMouseLeave={() => outFilter()}
                        className="filterButton mt-3"
                      >
                        {filterImg}
                        <span className={filterText}>
                          {getLocalString(
                            locales,
                            localNames.HOME_PAGE_FILTERSBUTTON
                          )}
                        </span>
                      </Space>
                    </Tooltip>
                    {isFiltersVisible && (
                      <div className="filtersContainer">
                        <div className="filters-wrapper">
                          <div style={{ flex: '1' }}>
                            <Select
                              id="select-application-status"
                              suffixIcon={<ArrowIcon />}
                              className="input-filter input-filter-voucher-status"
                              dropdownStyle={{ zIndex: 1050 }}
                              style={{ height: '3.02rem' }}
                              dropdownAlign={{ offset: [-11, 5] }}
                              allowClear={true}
                              placeholder={
                                getLocalString(
                                  locales,
                                  localNames?.HOME_PAGE_FILTERS_STATUS
                                ) || 'Voucher Status'
                              }
                              optionFilterProp="children"
                              onChange={value => {
                                if (isVoucherViewer(groups))
                                  return onStatusChangeVoucherViewer(value);
                                return onStatusChangeVoucher(value);
                              }}
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {voucherStatuses?.map(item => (
                                <Option
                                  id={`status-${item}-option`}
                                  key={item}
                                  value={item}
                                >
                                  {item === 'RESERVED'
                                    ? 'Δεσμευμένο'
                                    : item === 'REDEEMED'
                                      ? 'Εξαργυρωμένο'
                                      : item === 'PAID'
                                        ? 'Πληρωμένο'
                                        : item === 'PAYMENT_FAILED'
                                          ? 'Αποτυχία Πληρωμής'
                                          : item}
                                </Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {(isSupplier(groups) || isVoucherViewer(groups)) && (
                  <div>
                    <Divider className="filter-divider" />
                    <Table
                      scroll={{ x: true }}
                      id="apptrack-application-results-table"
                      className="results-table"
                      dataSource={results}
                      columns={suppplierColumns}
                      rowKey="id"
                      pagination={{
                        total: resultSizeSupplier,
                        current: currentPage,
                        showSizeChanger: true,
                        showTitle: true,
                        pageSizeOptions: [5, 10, 20, 50, 100, 200],
                        pageSize: pageSizeFlag,
                        onChange: (page, pageSize) => {
                          if (isVoucherViewer(groups)) {
                            handlePageChangeVoucherViewer(page, pageSize);
                          } else {
                            handlePageChangeVoucher(page, pageSize);
                          }
                        },
                      }}
                    />
                  </div>
                )}

                {isVoucherAuditor(groups) && (
                  <div>
                    <Row>
                      <div className="input-filter-voucher">
                        <div className="input-wrapper" style={{ flex: 1 }}>
                          <Input
                            id="afm-search-input"
                            allowClear
                            value={afmField}
                            onChange={handleAfmChange}
                            prefix={prefix}
                            placeholder="Εισάγετε Α.Φ.Μ. δικαιούχου"
                          />
                          {afmError && (
                            <div className="input-error">
                              Το πεδίο πρέπει να περιέχει ακριβώς 9 χαρακτήρες.
                            </div>
                          )}
                        </div>

                        <div className="input-wrapper" style={{ flex: 1 }}>
                          <Input
                            id="voucher-search-input"
                            allowClear
                            value={voucherNumber}
                            onChange={handleVoucherChange}
                            prefix={prefix}
                            placeholder="Εισάγετε Αριθμό Voucher"
                          />
                          {voucherNumberError && (
                            <div className="input-error">
                              Το πεδίο πρέπει να περιέχει ακριβώς 9 χαρακτήρες.
                            </div>
                          )}
                        </div>

                        <div className="input-wrapper" style={{ flex: 1 }}>
                          <Input
                            id="applicationNumber-search-input"
                            allowClear
                            value={applicationNumber}
                            onChange={handleΑpplicationNumberChange}
                            prefix={prefix}
                            placeholder="Εισάγετε Αριθμό Αίτησης"
                          />
                          {applicationNumberError && (
                            <div className="input-error">
                              Το πεδίο πρέπει να περιέχει ακριβώς 6 χαρακτήρες.
                            </div>
                          )}
                        </div>

                        <div id="search-voucher-wrapper">
                          <Button
                            id="search-voucher-button"
                            type="default"
                            className="ant-btn-primary"
                            label="Αναζήτηση"
                            disabled={
                              ((isNil(afmField) || afmField === '') &&
                                (isNil(voucherNumber) ||
                                  voucherNumber === '') &&
                                (isNil(applicationNumber) ||
                                  applicationNumber === '')) ||
                              (!isNil(afmField) && afmField.length !== 9) ||
                              (!isNil(voucherNumber) &&
                                voucherNumber.length !== 9) ||
                              (!isNil(applicationNumber) &&
                                applicationNumber.length !== 6)
                            }
                            onClick={() =>
                              dispatch(
                                fetchVoucherVoucherAuditorWithParams(
                                  afmField,
                                  voucherNumber,
                                  applicationNumber
                                )
                              )
                            }
                          />
                        </div>
                      </div>
                    </Row>
                  </div>
                )}

                {isVoucherAuditor(groups) && (
                  <div>
                    <Divider className="filter-divider" />
                    <Table
                      scroll={{ x: true }}
                      id="apptrack-application-results-table"
                      className="results-table"
                      dataSource={results}
                      columns={voucherAuditorColumns}
                      rowKey="id"
                      pagination={{
                        total: resultSizeVoucherAuditor,
                        current: currentPage,
                        showSizeChanger: true,
                        showTitle: true,
                        pageSizeOptions: [5, 10, 20, 50, 100, 200],
                        pageSize: pageSizeFlag,
                        onChange: (page, pageSize) => {
                          // console.log("page, pageSize",page,pageSize);
                          handlePageChangeVoucherAuditor(page, pageSize);
                        },
                      }}
                    />
                  </div>
                )}

                {isEmpty(results) &&
                  checkUniquenessCreate?.canCreate &&
                  !isSupplier(groups) &&
                  !isVoucherAuditor(groups) &&
                  !isVoucherViewer(groups) && (
                    <NoResults
                      id="apptrack-application-results-no-results"
                      description={'Δε βρέθηκαν αποτελέσματα'}
                      subDescription={''}
                    />
                  )}

                {iniFlag !== '1' && isBeneficiary(groups) && (
                  <NoResults
                    id="apptrack-application-results-no-results"
                    description={
                      'Δεν είστε εγκεκριμένος χρήστης του συστήματος Αλλάζω Συσκευή Θέρμανσης - Θερμοσίφωνες.'
                    }
                    subDescription={
                      'Παρακαλώ, Ξανασυνδεθείτε με διαφορετικό Χρήστη, ή απευθυνθείτε στο Help Desk του προγράμματος.'
                    }
                  />
                )}
              </Col>
            </Row>
          )}
        </div>
      </div>
    </main>
  );
};

export default AppTrackPage1;
